<template>
   <div>
     <div class="heading">
       <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
        </div>
            <img class="dividerline" src="../assets/img/sep.png" alt="">
            <h2>Committee Members</h2>
            <img class="dividerline" src="../assets/img/sep.png" alt="">
            <ul style="text-align:left" v-for="(data, i) in contactpersons" :key="i">
                <li v-html="data"></li>
            </ul>
            <hr/>
          <div class="row" style="align:center"><Contactemail/></div>  
      </div>
      
   </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import Contactemail from '@/components/sections/Contactemail'
  export default {
    name: 'Contact',
    components: {
      Loading,
      Contactemail
    },
    data () {
      return {
        msg: 'Contact',
        isLoading: false,
        fullPage: true,
        info: null,
        contactpersons: null
    }
  },
  methods: {
    onCancel() {
              console.log('User cancelled the loader.')
            }
  },
  mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/contacts')
      .then(response => {
        this.info = response.data
        this.contactpersons=this.info[0].contactpersons        
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.isLoading = false)
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue